import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Row, Col } from 'antd';

import { recoveryUpdateRequest } from '~/store/modules/auth/actions';

import { SaveOutlined, CodeOutlined, LoginOutlined, LockOutlined } from '@ant-design/icons';
import { Card, AppName, Title, ImageContainer, Form, Button, FormItem, Link } from '~/pages/_layouts/auth/styles';
import { Container } from './styles';

import image from '~/assets/images/login.jpg';

export default function RecoveryUpdate(props) {
  const dispatch = useDispatch();

  const { token } = props?.match?.params;

  const loading = useSelector(store => store.auth.loading);

  const [form] = Form.useForm();

  const onFinish = (values) => {
    const { code, password, passwordConfirm } = values;

    dispatch(recoveryUpdateRequest(token, code, password, passwordConfirm));
  }

  return (
    <Container>
      <Row style={{ height: '100%' }}>
        <Col xs={24} md={12} lg={11} xl={10} style={{ height: '100%', overflow: 'auto' }}>
          <Card>
            <AppName>
              <hr />
              <div>
                <span>StationUp</span>
                <span>DevOps</span>
              </div>
              <hr />
              <span>Powered by <a href="https://www.webstationdesign.com.br" target="_blank">WebStation</a></span>
            </AppName>

            <Title>Recuperação de senha</Title>

            <Form
              form={form}
              layout="vertical"
              onFinish={onFinish}
            >
              <Row>
                <Col xs={24}>
                  <p>Informe o código recebido por e-mail e crie uma nova senha.<br /></p>
                </Col>

                <Col xs={24}>
                  <FormItem
                    name="code"
                    rules={[{ required: true, message: 'Código é obrigatório' }]}
                  >
                    <div className="input-group">
                      <CodeOutlined />
                      <input type="text" name='codeText' maxLength={6} placeholder="Código" defaultValue={undefined} />
                    </div>
                  </FormItem>
                </Col>

                <Col xs={24}>
                  <FormItem
                    name="password"
                    rules={[{ required: true, message: 'Senha é obrigatória' }]}
                  >
                    <div className="input-group">
                      <LockOutlined />
                      <input type="password" name='passwordText' placeholder="Nova senha" defaultValue={undefined} />
                    </div>
                  </FormItem>
                </Col>

                <Col xs={24}>
                  <FormItem
                    name="passwordConfirm"
                    rules={[{ required: true, message: 'Confirmação é obrigatória' }, ({ getFieldValue }) => ({
                      validator(_, value) {
                        if (!value || getFieldValue('password') === value) {
                          return Promise.resolve();
                        }
                        return Promise.reject(new Error('As senhas não combinam'));
                      },
                    })]}
                  >
                    <div className="input-group">
                      <LockOutlined />
                      <input type="password" name='passwordConfirmText' placeholder="Confirme sua senha" defaultValue={undefined} />
                    </div>
                  </FormItem>
                </Col>

                <Col xs={24}>
                  <FormItem>
                    <Button
                      shape='aroud'
                      icon={<SaveOutlined />}
                      type="primary"
                      htmlType="submit"
                      loading={loading}
                    >
                      Salvar
                    </Button>
                  </FormItem>
                </Col>
              </Row>

              <Row>
                <Col xs={24} className="col-flex-center" style={{ marginTop: 40, marginBottom: 30 }}>
                  <Link to="/login" className="primary-color">
                    <LoginOutlined />
                    Voltar para Login
                  </Link>
                </Col>
              </Row>
            </Form>
          </Card>
        </Col>

        <Col xs={0} md={12} lg={13} xl={14} style={{ height: '100%', overflow: 'hidden' }}>
          <ImageContainer>
            <img src={image} height="120%" />
          </ImageContainer>
        </Col>
      </Row>
    </Container>
  );
}